import { Feature, StateManager } from '@tencent/workbench';
import BaseMobileContextMenuFeature from '@framework/workbench/common/feature/base-mobile-context-feature';
import { config } from './config';
import { TOUCH_SLIDE_INDEX } from '../../const/mobile-setting-const';

declare global {
    interface Window {
        isEditing: boolean;
    }
}

@Feature()
export class MoveSlideDownFeature extends BaseMobileContextMenuFeature {
    id = config.name;

    constructor(private readonly stateManager: StateManager) {
        super();
    }

    public moveSlideDown() {
        const index = this.stateManager.getValue(TOUCH_SLIDE_INDEX) || 0;
        const { isEditing } = window;
        if (isEditing) {
            return;
        }
        const arr: any[] = [];
        arr.push(this.getSelectionService().slides[index]);
        const toIndex = index + 2;
        // 处理最顶部幻灯片的case
        this.getUiDataService().presentation.moveSlide(toIndex, arr);
    }
}
